module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAP1BMVEVHcEz/iAD/iAD/iQD/iQD/iQD/iAD/iQD/iQD/iQD/iQD/iQD/iQD/iQD/dAD/hgD/iAD/iQD/igD/iAD/iQASxf0+AAAAFHRSTlMA5Q7EHPNYzaFyNNtMtQcpQ2eYjdT56A4AAACHSURBVBjTZY9ZFoQgDASjBAKoLNr3P+vE7YWZ6b/UI+mC6EzzwpT8RpYN6OSBamgCVgYwP3OVRadJMZZ+owiLv1Ea0FuQ9Z00AfZW3uuKdtKDwQodkIqu5W+HOjjMUR9B9BRc+i8EX2gdtZ7VrD+UoIUx8OBwXBVWeJxGDp4Nla6OnAar33wAUTAKLYWd1PQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon001.png
// module id = 224
// module chunks = 1